import { Field } from "formik";
import { useEffect, useState, useRef } from "react";
import { Form as BForm } from "react-bootstrap";
import ColorPicker, { useColorPicker } from "react-best-gradient-color-picker";
import TextInput from "../../../../../components/formfields/InputField";
import useClickOutside from "../../../../../hooks/useClickOutside";

type customPickerPropTypes = {
  setFieldValue?: any;
  name?: string;
  value?: string;
  label?: string;
  edit?: boolean;
  generator?: boolean;
  setValue?: any;
  renderOnlySolidMode?: boolean;
};
const CustomPicker = ({
  setFieldValue,
  setValue,
  name,
  value,
  edit = true,
  label = "Color Picker",
  generator = false,
  renderOnlySolidMode,
}: customPickerPropTypes) => {
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const [color, setColor] = useState<string>(value ?? "#7ADBD1");
  const [showSolidColors, setShowSolidColors] = useState<boolean | undefined>(false);

  useEffect(() => {
    setShowSolidColors(renderOnlySolidMode);
  }, [renderOnlySolidMode]);

  useColorPicker(color, setColor);

  const myRef = useRef(null);

  const handleClickOutside = () => {
    setColor(value ?? "#7ADBD1");
    setShowPicker(false);
    // handle outside click here
  };
  useClickOutside(myRef, handleClickOutside);

  useEffect(() => {
    if (generator) {
      setValue(color);
    } else {
      setFieldValue(name, color);
    }
  }, [color]);

  const [x, setX] = useState();
  const [y, setY] = useState();
  const getPosition = () => {
    const z: any = myRef?.current;
    const xs: any = z?.offsetLeft;
    setX(xs);

    const ys = z?.offsetTop;
    setY(ys);
  };

  useEffect(() => {
    getPosition();
  }, []);

  return (
    <>
      {label ? <BForm.Label>{label}</BForm.Label> : null}
      <div className="position-relative colorPickerInput">
        <label
          aria-hidden="true"
          htmlFor="colorLabel"
          className="colorLabel"
          style={{ background: `${value}` }}
          onClick={() => {
            edit && setShowPicker(!showPicker);
            setColor(value ?? "#7ADBD1");
          }}
        />
        <Field id="colorLabel" component={TextInput} value="" className="editField" disabled />
        {edit && showPicker && (
          <div className="colorPickerBox mt-5" ref={myRef} style={{ top: `${x}`, left: `${y}` }}>
            <ColorPicker value={color} onChange={setColor} hideColorTypeBtns={showSolidColors} />
          </div>
        )}
      </div>
    </>
  );
}

export default CustomPicker;